<template>
  <div class="reflex">
    <p class="text-center visit">
      You can also visit us on our website:
      <a href="#">www.exbazershop4comfort.com</a>
    </p>
    <div class="d-flex flex-row bd-highlight mt-5 pb-5 justify-content-end align-items-center">
      <div class="bd-highlight">
        <a href="https://www.facebook.com/elizabeth.onyenekwe/">
          <i class="fab fa-facebook art"></i>
        </a>
      </div>
      <div class="ml-3 bd-highlight">
        <a href="mailto:onyenekwelizabeth@gmail.com">
          <i class="fas fa-envelope art"></i>
        </a>
      </div>
      <div class="ml-3 bd-highlight">
        <a href="#">
          <i class="fab fa-instagram art"></i>
        </a>
      </div>
      <div class="ml-3 mr-5 bd-highlight">
        <a href="https://twitter.com/ElizabethOnyen6">
          <i class="fab fa-twitter art"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/page7/reflex.vue